import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import brigade_chips_icon from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg";
import car_train_icon from "../../../images/gameplay_ui/icons/car_train_icon.svg";
import load_icon from "../../../images/gameplay_ui/icons/sort_train/load_icon.svg";
import unload_icon from "../../../images/gameplay_ui/icons/sort_train/unload_icon.svg";
import {STATION_HEADER_COLORS} from "../GameStyleUI";
import SortCarTrainWindow_OrderCard from "./SortCarTrainWindow_OrderCard";
import GameData from "../../../gameplay/model/GameData";
import RuntimeGameData from "../../../gameplay/model/RuntimeGameData";
import StationPlaceCard from "../../../images/gameplay_ui/icons/station_places/StationPlaceCard";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import {CLIENT_NAMES} from "../../../constants/Constants";
import {IsPackOther} from "../../../gameplay/model/Balance";

export default class SortCarTrainWindow extends React.Component {
  constructor() {
    super();

    let clientsIndex = UtilsFunctions.getRoleNameIndex("Зам. по работе с клиентами");
    this.isClientMaster = UtilsFunctions.playerHasRole(clientsIndex);
  }

  componentDidMount() {
    if (!this.isClientMaster && !localStorage.getItem("notClientMasterMessage")) {
      alert("Загрузкой и выгрузкой вагонов может заниматься только Зам. по работе с клиентами");
      localStorage.setItem("notClientMasterMessage", "1")
    }
  }

  createScrollHeader(icon, text) {
    let mainStyle = {
      width: "133px", display: "flex", justifyContent: "space-between"
    }
    let iconStyle = {
      display: "block", width: `${20}px`, height: `${20}px`
    }
    let textStyle = {
      position: "relative",
      fontWeight: this.props.fontWeight ?? "bold",
      fontSize: `${18}px`,
      lineHeight: `${20}px`,
      textTransform: "uppercase"
    }
    return <div style={mainStyle} key={`scroll-header-${text.icon}`}>
      <img style={iconStyle} alt={'icon'} src={icon}/>

      <div style={textStyle}>
        {text}
      </div>
    </div>
  }

  createScroll(trainCarPacks, isLoad) {
    let mainStyle = {
      top: "60px"
    }
    let scrollStyle = {
      overflowY: "visible", overflowX: "hidden", height: "500px", width: "173px", marginTop: "20px"
    }
    let result = [];
    let cards = [];
    result.push(this.createScrollHeader(isLoad ? load_icon : unload_icon, isLoad ? "Погрузка" : "Выгрузка"));

    for (let i = 0; i < trainCarPacks.length; i++) {
      // disabled если не clientMaster
      cards.push(<SortCarTrainWindow_OrderCard key={'b' + i} disabled={!this.isClientMaster}
                                               trainCarsPack={trainCarPacks[i]} station={this.props.station}
                                               parent={this} isOrder={isLoad}/>)
    }
    result.push(<div key={'res'} style={scrollStyle}>
      {cards}
    </div>)
    return <div key={`res-scroll-${Number(isLoad)}`} style={mainStyle}>{result}</div>;
  }

  getCurrentTrainCarPacks() {
    let station = this.props.station;
    let used = 0;
    for (let i = 0; i < station.orderTrainPacks.length; i++) {
      used += GameData.CurrentGame.getOrderTrainCarById(station.orderTrainPacks[i]).trainCarCount;
    }

    return station.trainCars - used;
  }

  getClientKey(name) {
    for (let id in CLIENT_NAMES) {
      if (CLIENT_NAMES[id] === name) return id;
    }
    return null;
  }

  validateClientPlaces() {
    window.w = RuntimeGameData.CurrentGame;
    let station = this.props.station;
    let result = true;
    Object.keys(station.clientPlaces).forEach(client => {
      let count = 0;

      let data = RuntimeGameData.CurrentGame.getSortTrainData();

      Object.keys(data.onStation).forEach(trainCarId => {
        if (data.onStation[trainCarId]) {

          let pack = GameData.CurrentGame.getTrainCarById(Number(trainCarId));
          if (pack.client === client || client === this.getClientKey(pack.client) || (client === "other" && IsPackOther(pack.type))) {
            count++;
          }
        }
      });

      Object.keys(data.onLoad).forEach(trainCarId => {
        let pack = GameData.CurrentGame.getOrderTrainCarById(Number(trainCarId));

        if (pack && (pack.client === client || (client === "other" && IsPackOther(pack.type)))) {
          count += Math.ceil(data.onLoad[trainCarId] / 20);
        }

      });
      if (count > station.clientPlaces[client] + GameData.CurrentGame.getRentedPlaces(station.id, client)) {
        result = false;
      }
    });
    return result;
  }

  createClientPlaces() {
    let result = [];
    let style = {
      display: "flex"
    }
    let station = this.props.station;

    Object.keys(station.clientPlaces).forEach((client, num) => {
      let count = 0;

      let data = RuntimeGameData.CurrentGame.getSortTrainData();

      Object.keys(data.onStation).forEach(trainCarId => {
        if (data.onStation[trainCarId]) {

          let pack = GameData.CurrentGame.getTrainCarById(Number(trainCarId));
          if (pack.client === client || client === this.getClientKey(pack.client) || (client === "other" && IsPackOther(pack.type))) {
            count++;
          }
        }
      });

      Object.keys(data.onLoad).forEach(trainCarId => {
        let pack = GameData.CurrentGame.getOrderTrainCarById(Number(trainCarId));

        if (pack && (pack.client === client || (client === "other" && IsPackOther(pack.type)))) {
          count += Math.ceil(data.onLoad[trainCarId] / 20);
        }

      });

      result.push(<StationPlaceCard key={'stpc' + num} reserved={count}
                                    free={station.clientPlaces[client] + GameData.CurrentGame.getRentedPlaces(station.id, client)}
                                    client={client}/>)
    });
    return <div style={style}>
      {result}
    </div>;
  }

  render() {
    let station = this.props.station;
    let moveStyle = {
      position: "absolute",
      left: this.props.width / 2,
      top: this.props.height / 2 - 40,
      transform: window.innerWidth > 1500 ? "translate(-50%,-50%)" : "translate(-50%, -50%) scale(0.8)",
    }
    let runtimeChip = 0;
    for (let i = 0; i < station.trainCarsPacks.length; i++) {
      let runtimeValue = RuntimeGameData.CurrentGame.getSortTrainData().onStation[station.trainCarsPacks[i]];

      if (runtimeValue) {
        runtimeChip += 1;
      }
    }
    let trainCarsCount = 0;
    for (let i = 0; i < station.orderTrainPacks.length; i++) {
      let currentLoadCount = RuntimeGameData.CurrentGame.getSortTrainData().onLoad[station.orderTrainPacks[i]];
      if (currentLoadCount) {
        trainCarsCount += currentLoadCount;
        runtimeChip += Math.ceil(currentLoadCount / 20);
      }
    }

    let brigadeChips = station.brigadesChips + station.additionalChips + GameData.CurrentGame.getRentedBrigades("station", station.id) * 4;
    let colors = STATION_HEADER_COLORS[station.id];
    let currencyBlocks = [];
    currencyBlocks.push(<CurrencyCard
      key={'por'}
      title={"Порожние вагоны"}
      icon={car_train_icon}
      value={station.trainCars - trainCarsCount}
      size={20}
      fontSize={14}
      style={{
        marginLeft: "10px"
      }}
    />);
    currencyBlocks.push(<CurrencyCard
      key={'trud'}
      title={"Трудозатраты"}
      icon={brigade_chips_icon}
      value={brigadeChips - runtimeChip}
      size={20}
      fontSize={14}
      style={{
        marginLeft: "10px"
      }}
    />);
    let mainStyle = {
      display: "grid",
      gridTemplateColumns: "179px 1px 179px",
      paddingLeft: "20px",
      paddingTop: "40px",
      gridColumnGap: "30px"
    }
    let delimeterStyle = {
      background: "#C4C4C4", width: "1px", height: "505px", marginTop: "42px"
    }
    let content = [];

    content.push(this.createScroll(station.trainCarsPacks, false));
    content.push(<div key={"c1"} style={delimeterStyle}/>);
    content.push(this.createScroll(station.orderTrainPacks.filter(x => !GameData.CurrentGame.isOrderFull(x)), true));
    content = <div>
      <div style={{paddingTop: "40px", paddingLeft: "20px"}}>{this.createClientPlaces()}</div>
      <div style={mainStyle}>{content}</div>
    </div>
    let onHide = () => {
      alert("Недостаточно места у клиентов, вагонов или трудозатрат!")
    }
    if (station.trainCars - trainCarsCount >= 0 && brigadeChips - runtimeChip >= 0 && this.validateClientPlaces()) {
      onHide = this.props.onHide;
    }
    return <div className="in-game-popup" style={{
      width: this.props.width, height: this.props.height, background: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)"
    }}>
      <div style={moveStyle}>
        <GameWindowHeader width={451} height={40} colorStart={colors[0]} colorEnd={colors[1]}
                          onHide={onHide} title={`${station.name}: сортировка`} isClosable={true}
                          currencyBlocks={currencyBlocks}/>
        <GameWindowBg color={"#F2F2F2"} width={451} height={710} value={content}/>
      </div>

    </div>;
  }
}
